import React from "react";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

const About = () => {
  // Getting User Data from Redux Store
  const myData = useSelector((state) => state.user);
  console.log("About", myData);

  return (
    <>
      <section className="about-us">
        <h1>Our 6 years of achievements</h1>
        <p>We deals in all kinds of web projects</p>
      </section>
      <div className="about-cards">
        <div className="a-card">
          <h3 className="card-h3">Education</h3>
          <p>
            We have partnered with some of the leading education and financial
            institutions, and nonprofits to modernize the way the world learns.
          </p>
        </div>
        <div className="b-card">
          <h3 className="card-h3">Finance</h3>
          <p>
            Our experts have teamed up with a wide range of organisation's to
            help them adjust to fast-paced changes in the financial sector.{" "}
          </p>
        </div>
        <div className="c-card">
          <h3 className="card-h3">Healthcare</h3>
          <p>
            Our apps have contributed to the technological revolution in the
            healthcare industry, from educating medical students to managing
            patients in clinics.
          </p>
        </div>
        <div className="d-card">
          <h3 className="card-h3">Travel</h3>
          <p>
            We enable leading travel & hospitality search engines with our
            dedicated team of software developers, machine learning and data
            engineers.
          </p>
        </div>
      </div>
    </>
  );
};

export default About;
